export default __webpack_public_path__ + "static/Wizard_05-a5b6b79ac293ccdb68903992d6a8bbbd.webp";